import { Enum } from './Enum';

export class ProgramTaskReviewStatus extends Enum {
  translationKey = 'programTaskReviewStatus';

  static asArray: ProgramTaskReviewStatus[] = [];

  static byKey: { [name: string]: ProgramTaskReviewStatus } = {};

  static readonly NOT_REVIEWED = new ProgramTaskReviewStatus('NOT_REVIEWED');

  static readonly IN_PROGRESS = new ProgramTaskReviewStatus('IN_PROGRESS');

  static readonly ESCALATED_ACCOUNTS = new ProgramTaskReviewStatus(
    'ESCALATED_ACCOUNTS',
  );

  static readonly REVIEWED = new ProgramTaskReviewStatus('REVIEWED');

  constructor(public readonly value: string) {
    super();
    ProgramTaskReviewStatus.asArray.push(this);
    ProgramTaskReviewStatus.byKey[value] = this;
  }
}

export default ProgramTaskReviewStatus;
